import React from 'react';
import { useTranslation } from 'react-i18next';

export default function DebugPanel({ 
  currentTime, 
  subscriptionId,
  categoryId, 
  schedule, 
  activePlan, 
  lastFetchedAt,
  slideshowInterval,
  onSlideshowIntervalChange,
  onThumbnailClick
}) {
  const { t } = useTranslation();

  const subPlans = Array.isArray(schedule?.SubPlan) ? schedule.SubPlan : [];

  return (
    <div style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(255,255,255,0.95)',
      color: '#000',
      padding: '10px',
      fontSize: '14px',
      maxHeight: '60vh',
      overflowY: 'auto',
      borderTop: '2px solid #ccc'
    }}>
      <p><strong>{t('debugPanel.currentTime')}:</strong> {currentTime}</p>
      <p><strong>{t('debugPanel.subscriptionId')}:</strong> {subscriptionId}</p>
      
      <div style={{ marginTop: '10px', marginBottom: '10px' }}>
        <label htmlFor="slideshow-interval-input" style={{ marginRight: '10px' }}>
          <strong>{t('debugPanel.slideshowIntervalSeconds')}:</strong>
        </label>
        <input
          id="slideshow-interval-input"
          type="number"
          min="1"
          value={slideshowInterval}
          onChange={(e) => onSlideshowIntervalChange(e.target.value)}
          style={{
            padding: '5px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            width: '80px'
          }}
        />
        <small style={{ marginLeft: '10px', color: '#666' }}>
          {t('debugPanel.overrideSlideDuration')}
        </small>
      </div>
      
      <p><strong>{t('debugPanel.schedule')}:</strong></p>
      <ul>
        <li>{t('debugPanel.start')}: {schedule?.start_datetime}</li>
        <li>{t('debugPanel.end')}: {schedule?.end_datetime}</li>
        <li>{t('debugPanel.totalImages')}: {schedule?.TotalImagesCount}</li>
      </ul>
      <p><strong>{t('debugPanel.lastFetched')}:</strong> {lastFetchedAt?.toLocaleString('ja-JP')}</p>

      {subPlans.length > 0 ? (
        subPlans.map((sub, idx) => {
          const isActive = sub === activePlan;
          const images = Array.isArray(sub?.images) ? sub.images : [];

          return (
            <div
              key={idx}
              style={{
                marginBottom: '10px',
                border: isActive ? '2px solid #426559' : '1px solid #ccc',
                padding: '5px',
                backgroundColor: isActive ? '#e8f4f1' : 'transparent',
              }}
            >
              <h4>{t('debugPanel.subSchedule')} {idx + 1}</h4>
              <ul>
                <li>{t('debugPanel.startDate')}: {sub.start_date}</li>
                <li>{t('debugPanel.endDate')}: {sub.end_date}</li>
                <li>{t('debugPanel.startTime')}: {sub.start_time}</li>
                <li>{t('debugPanel.endTime')}: {sub.end_time}</li>
                <li>{t('debugPanel.durationSeconds')}: {sub.duration_seconds}</li>
                <li>{t('debugPanel.totalImages')}: {sub.total_image_count}</li>
              </ul>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {images.map((img) => {
                  const imageInfo = schedule?.Images?.find((i) => i.image_id === img.image_id);
                  if (!imageInfo?.image_id) return null;
                  
                  // Backend no longer sends image_url, use image_id to fetch via proxy
                  // URL encode image_id to handle special characters (e.g., colons)
                  // Include subscriptionId and categoryId for schedule caching
                  const categoryParam = categoryId ? `&categoryId=${encodeURIComponent(categoryId)}` : '';
                  const imageSrc = `/api/images/${encodeURIComponent(imageInfo.image_id)}?subscriptionId=${encodeURIComponent(subscriptionId)}${categoryParam}`;
                  
                  return (
                    <img
                      key={img.image_id}
                      src={imageSrc}
                      alt={img.image_id}
                      style={{
                        width: '100px',
                        height: '100px',
                        objectFit: 'contain',
                        border: '1px solid #ccc',
                        cursor: 'pointer'
                      }}
                      onClick={() => onThumbnailClick?.(img.image_id)}
                      onContextMenu={(e) => e.preventDefault()}
                      draggable={false}
                    />
                  );
                })}
              </div>
            </div>
          );
        })
      ) : (
        <p>{t('debugPanel.noSubSchedules')}</p>
      )}
    </div>
  );
}
